import { registerCustomElement } from "UI/UI.ElementarControls/Utils/CustomElementUtils";
import { IAction, ITwoStateAction } from "../Actions/IAction";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownMenuTwoStateItem extends DropDownMenuItem {
    //#region Fields
    private _checked: boolean = false;
    //#endregion Fields

    //#region Properties
    //#endregion Properties

    //#region Constructors
    //#endregion Constructors

    //#region Methods
    public static createDropTwoStateMenuItem(action: ITwoStateAction, icon: string, fnc: () => Promise<void>, locKey: string, enabled: boolean = false, priority: number = 15, locParams?: string[]): DropDownMenuItem {
        const element = new DropDownMenuTwoStateItem();
        element._checked = action.checked;
        return this._initDropDownElement(element, icon, fnc, locKey, enabled, priority, locParams);
    }

    protected override _setIconOnElement(_element: DropDownMenuItem, _action: IAction, icon: string): void {
        this._icon = icon;
        if (this._checked) {
            this._setIcon(this.icon, false);
        }

        this._eventsController.addListener(this, "click", () => {
            this._checked = !this._checked;
            this._setIcon(this._checked ? "" : this._icon, false);
        });
    }
    //#endregion Methods
}

registerCustomElement("tsc-DropDownMenuTwoStateItem", DropDownMenuTwoStateItem);
